/**
 * @generated SignedSource<<cff0f780fbf7462c1a00afbdbb801af7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserCertificationsDisplay$data = {
  readonly allCertifications: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly " $fragmentType": "UserCertificationsDisplay";
};
export type UserCertificationsDisplay$key = {
  readonly " $data"?: UserCertificationsDisplay$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCertificationsDisplay">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCertificationsDisplay",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allCertifications",
      "storageKey": null
    }
  ],
  "type": "GwtUser",
  "abstractKey": null
};

(node as any).hash = "b311b7ee34d612d2582fec4f0052121f";

export default node;
